import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { DataListTableElement } from '@el-data-list-table';
import { TranslateService } from '@ngx-translate/core';

import { IIdentity, IProfilePicture } from '@shared/interfaces';

export interface historyData {
  action: string;
  lend_on_date: string;
  return_on_date: string;
  remarks: string;
  name: string;
  avatar: string; // Profile picture or avatar
}

@Component({
  selector: 'app-asset-allocate-history',
  templateUrl: './asset-allocate-history.html',
  styleUrls: ['./asset-allocate-history.scss'],
})
export class AssetAllocateHistoryPopupComponent implements OnInit {
  @Input() allIdentities: IIdentity[];
  @Input() profilePictures: IProfilePicture[];

  filteredItems: historyData[];
  pageSize = 10;
  pageIndex = 0;
  totalItems = 0;

  usersList: DataListTableElement[] = [];
  filterInput = new FormControl();
  filterValue = '';
  isListLoading = true;

  constructor(
    public dialogRef: MatDialogRef<AssetAllocateHistoryPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public historyData: historyData[],
    public translate: TranslateService,
    private paginatorIntl: MatPaginatorIntl
  ) {
    this.filteredItems = this.historyData.reverse();

    this.totalItems = this.filteredItems.length;

    this.paginatorIntl.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number
    ) => {
      if (length === 0) {
        return `Page 1 of 1`;
      }
      const amountPages = Math.ceil(length / pageSize);
      return `Page ${page + 1} of ${amountPages}`;
    };
  }
  ngOnInit() {
    this.isListLoading = true;
  }

  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
  }
  filterItems(filterValue: string) {
    this.filteredItems = this.historyData
      .filter((item) =>
        item.lend_on_date.toLowerCase().includes(filterValue.toLowerCase())
      )
      .reverse();
    this.totalItems = this.filteredItems.length;
    this.pageIndex = 0;
  }

  filterClear() {
    this.filterValue = '';
    this.filteredItems = [...this.historyData].reverse();
    this.totalItems = this.historyData.length;
    this.pageIndex = 0;
  }

  formatSalutation(salutation: string): string {
    return salutation.endsWith('.') ? salutation : `${salutation}.`;
  }
}
